export default __webpack_public_path__ + "static/dogBarking-7d518b5bb69dc923061c370b4c7ce88d.png";